import { Auth } from "aws-amplify";
import { redirect } from "react-router-dom";
import * as React from "react";
import { useContext } from "react";
// Note this is client-side stripe API, so you cant call things like stripe.customers.retrieve etc
import { MenuItem } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import {
  STRIPE_SUB_STATUS,
  STRIPE_SUBSCR_ID,
} from "../services/user/cognitoService";
import { setCancelAtEndOfPeriod } from "../services/api/stripeService";
import { CognitoUserContext } from "../contexts/cognitoUserContext.js";



export default function ReactivateSubscription({ visible }) {
  const { cognitoUser, setCognitoUser } = useContext(CognitoUserContext);
  let display = visible ? "inline" : "none";
  // Handler for the button click event
  async function handleClick(e) {
    const subscriptionId= cognitoUser.attributes[STRIPE_SUBSCR_ID];
    setCancelAtEndOfPeriod(false, subscriptionId);
    loader();
    display= 'none';
    redirect("/");
  }

  const loader = async () => {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true })
    user.attributes[STRIPE_SUB_STATUS]= "ACTIVE";
    setCognitoUser(user); // Update context with refreshed user attributes
    display = 'none';
  };

  return (
    <MenuItem
      onClick={handleClick}
      sx={{ display: display, color:'red' }}
      variant="contained"
    >
      <Tooltip title="Reactivate your subscribtion">
        <SubscriptionsIcon />
      </Tooltip>
    </MenuItem>
  );
}
